export default "__VITE_ASSET__DM4T2FO2__"